import React, { useState } from 'react';
import Filters from './Filters/Filters';
import { makeStyles } from '@material-ui/core/styles';
import { FiltersInterface } from './consts';
import AllSubscriptionGrid from './Elements';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1
  }
}));

const SubscriptionGrid = () => {
  const classes = useStyles();
  const [filters, setFilter] = useState<FiltersInterface>({});

  const updateFilters = (filters: FiltersInterface) => {
    setFilter(filters);
  };

  return (
    <div className={classes.container}>
      <Filters onFiltersUpdated={updateFilters}></Filters>
      <AllSubscriptionGrid filters={filters}></AllSubscriptionGrid>
    </div>
  );
}

export default SubscriptionGrid;